import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/ic-drop-down.svg'
import _imports_1 from '@/assets/images/ic-users.svg'
import _imports_2 from '@/assets/images/ic-exit.svg'


const _hoisted_1 = { class: "access-btn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Управление доступом", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "20"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Выйти", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
    }, _toDisplayString(_ctx.fullLabel), 1),
    _createElementVNode("img", {
      class: "dropdown-img",
      src: _imports_0,
      style: _normalizeStyle({transform: _ctx.isAccessMenuOpen ? 'rotate(180deg)' : ''})
    }, null, 4),
    (_ctx.isAccessMenuOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dropdown",
          style: _normalizeStyle({bottom: !_ctx.$store.state.auth.isAdmin ? '-54px' : '' })
        }, [
          (_ctx.$store.state.auth.isAdmin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "access-control_btn",
                onMouseup: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$router.push({ name: 'access-control' });})
              }, _hoisted_4, 32))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "exit_btn",
            onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
          }, _hoisted_7, 32)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}